module.exports = "<div class=\"user-details-component user-vouches\">\r\n  <div class=\"title\">\r\n    <h4>\r\n      <span class=\"fa fa-child\"></span>\r\n      REFERENCES\r\n    </h4>\r\n  </div>\r\n  <div class=\"details\">\r\n    <div class=\"vouches-grid\">\r\n      <div id=\"vouches-grid\" kendo-grid k-options=\"vm.gridOptions\"></div>\r\n    </div>\r\n  </div>\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/common/Components/user-vouches/user-vouches.html
 ** module id = 607
 ** module chunks = 0
 **/